export interface ValidationResult {
  valid: boolean;
  startError?: string;
  endError?: string;
}

export function compareLocalDates(a: string, b: string): number {
  const [ay, am, ad] = a.split('-').map(Number);
  const [by, bm, bd] = b.split('-').map(Number);
  if (ay !== by) return ay < by ? -1 : 1;
  if (am !== bm) return am < bm ? -1 : 1;
  if (ad !== bd) return ad < bd ? -1 : 1;
  return 0;
}

export function normalizeTime(t: string): number {
  const [h, m] = t.split(':').map(Number);
  if (isNaN(h) || isNaN(m)) return -1;
  return h * 60 + m;
}

export function validateDateRange(startDate: string, endDate: string): ValidationResult {
  if (!startDate || !endDate) return { valid: true };
  const cmp = compareLocalDates(startDate, endDate);
  if (cmp > 0) return { valid: false, startError: 'Start date cannot be after end date.', endError: 'End date cannot be before start date.' };
  return { valid: true };
}

export function validateTimeRange(startTime: string, endTime: string, options?: { startLabel?: string; endLabel?: string }): ValidationResult {
  if (!startTime || !endTime) return { valid: true };
  const sm = normalizeTime(startTime);
  const em = normalizeTime(endTime);
  if (sm === -1 || em === -1) return { valid: true };

  const { startLabel, endLabel } = options ?? {};

  if (sm === em) {
    return { valid: false as const, startError: 'Time In and Time Out cannot be the same.', endError: 'Time In and Time Out cannot be the same.' };
  }

  return { valid: true };
}

export function validateDateTimeRange(
  startDate: string, startTime: string,
  endDate: string, endTime: string
): ValidationResult {
  if (!startDate || !endDate || !startTime || !endTime) return { valid: true };
  const dateCmp = compareLocalDates(startDate, endDate);
  if (dateCmp > 0) return { valid: false, startError: 'Start date cannot be after end date.', endError: 'End date cannot be before start date.' };
  if (dateCmp < 0) return { valid: true };
  return validateTimeRange(startTime, endTime);
}
